import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";


export class CropAPI {

  allCrop: any = (data: any) => {
    return axios.post("/crop/list", data, { headers: AuthHeader() });
  };

  cropList: any = () => {
    return axios.get("/crop/list",{ headers: AuthHeader() });
  };

  activeCropList: any = () => {
    return axios.get("/crop/activeList", { headers: AuthHeader() });
  };

  createNewCrop: any = (data: any) => {
    return axios.post("/crop/add", data, { headers: AuthHeader() });
  };

  changeCropStatusById: any = (id: number) => {
    return axios.put(
      "/crop/changeStatus",
      { id: id },
      { headers: AuthHeader() }
    );
  };

  deleteCrop: any = (id: number) => {
    return axios.delete("/crop/delete", {
      data: { id: id },
      headers: AuthHeader(),
    });
  };

  getCropById: any = (id: number) => {
    return axios.get(`/crop/details/${id}`, { headers: AuthHeader() });
  };

  updateCrop: any = (data: any) => {
    return axios.put("/crop/update", data, {
      headers: AuthHeader(),
    });
  };
  
}
